import { defineStyle } from "@chakra-ui/react";

export const primary = defineStyle({
  bg: "brand.500",
  color: "white",
  _hover: {
    bg: "brand.300",
  },
  _active: {
    bg: "brand.900",
    color: "white",
  },
  "[data-active]": {
    bg: "brand.900",
    color: "white",
  },
  _disabled: {
    bg: "content.tertiary",
    color: "white",
    _hover: {
      bg: "content.tertiary",
      color: "white",
    },
  },
  _dark: {
    bg: "cdsIndigo.200",
    color: "content.primary",
    _hover: {
      bg: "cdsIndigo.300",
      color: "darkModeHoverColor.DEFAULT",
    },
    _active: {
      bg: "cdsIndigo.400",
      color: "darkModeHoverColor.DEFAULT",
    },
    "[data-active]": {
      bg: "cdsIndigo.400",
      color: "darkModeHoverColor.DEFAULT",
    },
    _disabled: {
      bg: "disabledGray.DEFAULT",
      color: "content.primary",
      _hover: {
        bg: "disabledGray.DEFAULT",
        color: "content.primary",
      },
    },
  },
});

export const secondary = defineStyle({
  color: "brand.400",
  _hover: {
    color: "brand.700",
    bg: "brand.50",
  },
  _active: {
    color: "cdsIndigo.700",
    bg: "cdsIndigo.50",
    borderColor: "cdsIndigo.400",
    _hover: {
      bg: "cdsIndigo.100",
      borderColor: "cdsIndigo.500",
    },
  },
  "[data-active]": {
    color: "cdsIndigo.700",
    bg: "cdsIndigo.50",
    borderColor: "cdsIndigo.400",
    _hover: {
      bg: "cdsIndigo.100",
      borderColor: "cdsIndigo.500",
    },
  },
  _disabled: {
    color: "content.tertiary",
    borderColor: "content.tertiary",
    bg: "transparent",
    _hover: {
      color: "content.tertiary",
      borderColor: "content.tertiary",
      bg: "transparent",
    },
  },
  _dark: {
    color: "cdsIndigo.200",
    _hover: {
      bg: "cdsIndigo.300",
      color: "cdsIndigo.100",
    },
    _active: {
      bg: "brand.300",
      color: "cdsIndigo.100",
    },
    "[data-active]": {
      bg: "brand.300",
      color: "cdsIndigo.100",
    },
    _disabled: {
      color: "disabledGray.DEFAULT",
      borderColor: "content.tertiary",
      bg: "transparent",
      _hover: {
        color: "disabledGray.DEFAULT",
        borderColor: "content.tertiary",
        bg: "transparent",
      },
    },
  },
});

export const tertiary = defineStyle({
  color: "brand.400",
  bg: "cdsIndigo.50",
  _hover: {
    color: "cdsIndigo.50",
    bg: "brand.200",
  },
  _active: {
    color: "brand.900",
    bg: "brand.100",
  },
  "[data-active]": {
    color: "brand.900",
    bg: "brand.100",
  },
  _disabled: {
    color: "content.tertiary",
    bg: "darkModeHoverColor.DEFAULT",
    _hover: {
      color: "content.tertiary",
      bg: "darkModeHoverColor.DEFAULT",
    },
  },
  _dark: {
    bg: "cdsIndigo.400",
    color: "cdsIndigo.100",
    _hover: {
      bg: "cdsIndigo.100",
      color: "cdsIndigo.400",
    },
    _active: {
      bg: "cdsIndigo.300",
      color: "cdsIndigo.50",
    },
    "[data-active]": {
      bg: "cdsIndigo.300",
      color: "cdsIndigo.50",
    },
    _disabled: {
      color: "disabledGray.text",
      bg: "darkModeHoverColor.DEFAULT",
      _hover: {
        color: "disabledGray.text",
        bg: "darkModeHoverColor.DEFAULT",
      },
    },
  },
});
